import React, { Suspense, useEffect } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'
import '@fontsource/poppins'
import '@fontsource/poppins/300.css'
import '@fontsource/poppins/400.css'
import '@fontsource/poppins/500.css'
import '@fontsource/poppins/600.css'
import '@fontsource/poppins/700.css'
import { useStore } from 'react-redux'
import { setUpInterceptor } from './httpClient'
import ProtectedRoute from './ProtectedRoute'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const ResetPassword = React.lazy(() => import('./views/pages/forgot/ResetPassword'))
const NewPassword = React.lazy(() => import('./views/pages/new-password/NewPassword'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

const App = () => {
  const store = useStore()
  setUpInterceptor(store)

  // Redirect logic for reset-password URLs without hash
  useEffect(() => {
    const currentPath = window.location.pathname
    if (currentPath.startsWith('/reset-password/')) {
      const token = currentPath.split('/reset-password/')[1]
      window.location.href = `/#/reset-password/${token}`
    }
  }, [])

  return (
    <HashRouter>
      <Suspense fallback={loading}>
        <Routes>
          <Route exact path="/login" name="Login Page" element={<Login />} />
          <Route exact path="/invite/:token" name="Register Page" element={<Register />} />
          <Route exact path="/forgot-password" name="Forgot Password" element={<ResetPassword />} />
          <Route
            exact
            path="/reset-password/:token"
            name="New Password"
            element={<NewPassword />}
          />
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route
            path="*"
            name="Home"
            element={
              <ProtectedRoute>
                <DefaultLayout />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Suspense>
    </HashRouter>
  )
}

export default App
